<template>
  <div class="noResult-warp">
    <div class="noResult-box">
      <img :src="noResultImg">
      <div class="noResult-tip">暂无相关记录</div>
    </div>
  </div>
</template>

<script>
import noResultImg from '@/assets/images/no-payment.png'
export default {
  name: 'noResult',
  data () {
    return {
      noResultImg
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
  .noResult-warp {
    width: 100%;
    height: calc(100vh - 90px);
    text-align: center;
    background-color: #FFFFFF;
    img {
      width: 184px;
      height: 174px;
      margin-top: 111px;
    }
    .noResult-tip {
      font-size: 14px;
      color: #a0a0a0;
      margin-top: 24px;
      font-size: 14px;
      font-weight: 400;
      color: #232325;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/noPaymentList.vue